<div class="confirm-header">
    {{modalText$ | async | translate}}
</div>
